// hide header on scroll down - updated

document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector('.header');
    let lastScrollTop = 0;
    const threshold = 100; // Minimum scroll amount before hiding

    if (!header) return;

    // Check if sticky header is enabled in settings (data attribute on header)
    const isStickyEnabled = header.getAttribute('data-enable-sticky-header') === 'true';
    if (!isStickyEnabled) return;

    window.addEventListener('scroll', function () {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        // Ensure we don't trigger when scrolling at the very top (bounce effect)
        if (scrollTop < 0) return;

        if (scrollTop > lastScrollTop && scrollTop > threshold) {
            // Scrolling down
            if (!document.body.classList.contains('is-hover-cart-open')) {
                header.classList.add('header--hidden');
            }
        } else {
            // Scrolling up
            header.classList.remove('header--hidden');
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
    }, { passive: true });
});

window.toggleReadMore = function (btn) {
  const text = btn.closest('.product__description').querySelector('.custom-color-text');
  text.classList.toggle('expanded');
  const isExpanded = text.classList.contains('expanded');
  btn.textContent = isExpanded ? btn.dataset.readLess : btn.dataset.readMore;
};

// Initialize read more buttons - hide if content doesn't overflow
document.addEventListener('DOMContentLoaded', function() {
  const readMoreButtons = document.querySelectorAll('.read-more-btn');
  
  readMoreButtons.forEach(function(btn) {
    const text = btn.closest('.product__description').querySelector('.custom-color-text');
    
    if (text) {
      // Check if content is actually truncated
      const isOverflowing = text.scrollHeight > text.clientHeight;
      
      if (!isOverflowing) {
        btn.style.display = 'none';
      }
    }
  });
});

// Mobile product card hover toggle — V2: open quick-view drawer on mobile
document.addEventListener('click', function(e) {
  const toggleBtn = e.target.closest('.js-mobile-hover-toggle');

  if (toggleBtn) {
    e.preventDefault();
    e.stopPropagation();

    const productItem = toggleBtn.closest('.product-item');
    if (!productItem) return;

    // On mobile (<=719px), open the quick-view drawer instead
    if (window.innerWidth <= 719) {
      const quickViewBtn = productItem.querySelector('[data-quick-shop-trigger="quick-view"]');
      if (quickViewBtn) {
        quickViewBtn.click();
        return;
      }
      // Fallback: if product has no variants (quick-add), use the old overlay
      const quickAddBtn = productItem.querySelector('[data-quick-shop-trigger="quick-add"]');
      if (quickAddBtn) {
        quickAddBtn.click();
        return;
      }
    }

    // Desktop or fallback: use the overlay on photo
    document.querySelectorAll('.product-item.mobile-hover-active').forEach(item => {
      if (item !== productItem) {
        item.classList.remove('mobile-hover-active');
      }
    });
    productItem.classList.toggle('mobile-hover-active');
    return;
  }

  // Auto-close overlay when size/option is selected
  if (
      e.target.closest('.product-item__variant-info input') ||
      e.target.closest('.product-item__variant-info button') ||
      e.target.closest('.product-chips-options__item--chip')
  ) {
      setTimeout(() => {
        document.querySelectorAll('.product-item.mobile-hover-active').forEach(item => {
            item.classList.remove('mobile-hover-active');
        });
      }, 300);
  }

  // Close if clicking outside
  if (!e.target.closest('.product-item__variant-info')) {
      document.querySelectorAll('.product-item.mobile-hover-active').forEach(item => {
          item.classList.remove('mobile-hover-active');
      });
  }

}, true); // Use Capture phase

const menuButton = document.querySelector('[data-js-menu-button]');

function closeDrawerMenu() {
  const drawer = document.querySelector('.drawer-menu');
  if (!drawer) return;

  drawer.classList.remove(
    'active',
    'visible',
    'animation--drawer-menu-revealed'
  );

  if (menuButton) {
    menuButton.setAttribute('aria-expanded', 'false');
    menuButton.setAttribute('aria-label', 'Open menu modal');
  }

  const body = document.body;

  body.classList.remove(
    'mobile-menu-open',
    'scroll-lock'
  );

  body.removeAttribute('data-fluorescent-overlay-open');
  body.removeAttribute('style');
}

/* Attach listener safely (for Swym lazy load) */
document.addEventListener('click', function (e) {
  const wishlist = e.target.closest('.swym-wishlist');
  if (!wishlist) return;

  // iOS needs a tiny delay
  setTimeout(closeDrawerMenu, 400);
});

/* Extra support for iOS touch */
document.addEventListener('touchend', function (e) {
  const wishlist = e.target.closest('.swym-wishlist');
  if (!wishlist) return;

  setTimeout(closeDrawerMenu, 400);
});

// collection filter

document.addEventListener('DOMContentLoaded', function() {
  var bannerTrigger = document.getElementById('banner-filter-trigger');
  // Target the mobile filter toggle which is the most reliable drawer trigger
  var realTrigger = document.querySelector('[data-mobile-filters-toggle]');
  
  if (bannerTrigger && realTrigger) {
    bannerTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      realTrigger.click();
    });
  }
});

/**
 * Quick Cart Hover Option
 * Opens the quick cart on hover if the setting is enabled in the header section.
 */
// Helper to find the quick-cart section instance
function getQuickCartInstance() {
  const instances = window.Shopify?.theme?.sections?.instances || [];
  return instances.find(instance => instance.type === 'quick-cart');
}

let closeCartTimeout;
let lastOpenAt = 0;
const CART_OPEN_GRACE_MS = 700;

// Rastreamos la posicion real del cursor. Al abrirse el drawer, el overlay y el
// panel se pintan por encima del icono del carrito, asi que :hover y relatedTarget
// dan falsas senales de "el cursor salio" y provocaban un pestaneo (abre/cierra)
// en portatiles mas lentos. Con la geometria del puntero decidimos si sigue sobre
// el icono o el panel sin depender de que capa esta encima.
let __qcPointer = { x: -1, y: -1 };
document.addEventListener('mousemove', function (e) {
  __qcPointer.x = e.clientX;
  __qcPointer.y = e.clientY;
}, { passive: true });

function pointerOverCartZone() {
  var x = __qcPointer.x, y = __qcPointer.y;
  if (x < 0 || y < 0) return false;
  // Sobre el panel del drawer: hit-test real (fiable incluso a mitad de animacion,
  // y su bounding rect es inestable mientras se desliza).
  var el = document.elementFromPoint(x, y);
  if (el && el.closest && el.closest('.quick-cart__container')) return true;
  // Sobre el icono: usamos su rect (estable) porque al abrir el drawer el overlay
  // se pinta encima del icono y el hit-test devolveria el overlay por error.
  var icon = document.querySelector('[data-js-cart-icon]');
  if (icon) {
    var r = icon.getBoundingClientRect();
    var pad = 4;
    if (r.width > 0 && x >= r.left - pad && x <= r.right + pad && y >= r.top - pad && y <= r.bottom + pad) return true;
  }
  return false;
}

function openQuickCart() {
  clearTimeout(closeCartTimeout);
  
  // Calculate dynamic header offset including announcement bar and scroll position
  const header = document.querySelector('.header__outer-wrapper') || document.querySelector('[data-section-type="header"]');
  if (header) {
      document.documentElement.style.setProperty('--quick-cart-offset', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
  }

  // Use instance method if available
  const instance = getQuickCartInstance();
  const quickCartWrapper = document.querySelector('.quick-cart__wrapper');
  // Check active class on wrapper (standard theme behavior)
  const isCartOpen = quickCartWrapper && quickCartWrapper.classList.contains('active');
  
  if (!isCartOpen) {
      if (instance) {
          instance.openQuickCart();
      } else {
          // El bus de eventos del tema (Fluorescent) es privado y
          // window.Shopify.theme.sections.instances viene vacio, asi que no hay
          // instancia ni escucha del CustomEvent nativo. Disparamos el click del
          // icono, que es la via nativa del tema para abrir el quick cart
          // (theme.js hace preventDefault + emite quick-cart:open internamente).
          const icon = document.querySelector('[data-js-cart-icon]');
          if (icon) icon.click();
      }
      document.body.classList.add('is-hover-cart-open');
  }
  // Marca de apertura: durante la animacion de entrada, el overlay/panel se
  // pintan sobre el icono y :hover/relatedTarget dan falsos "salio", asi que
  // ignoramos peticiones de cierre en esta ventana de gracia (mata el pestaneo).
  lastOpenAt = (window.performance && performance.now) ? performance.now() : Date.now();
}

function closeQuickCart() {
  const instance = getQuickCartInstance();
  const closeBtn = document.querySelector('.quick-cart__close-icon');
  
  if (instance && typeof instance.close === 'function') {
      instance.close();
  } else if (closeBtn) {
       closeBtn.click();
  } else {
      // Last resort: remove class manually (not ideal but works for visuals)
      const quickCartWrapper = document.querySelector('.quick-cart__wrapper');
      if (quickCartWrapper) quickCartWrapper.classList.remove('active');
      document.body.removeAttribute('data-fluorescent-overlay-open');
  }
  document.body.classList.remove('is-hover-cart-open');
}

function scheduleCloseCart() {
  clearTimeout(closeCartTimeout);
  closeCartTimeout = setTimeout(() => {
      const now = (window.performance && performance.now) ? performance.now() : Date.now();

      // 1) Ventana de gracia tras abrir: mientras el drawer entra, el overlay se
      //    pinta sobre el icono y dispara falsos "salio" -> reprogramamos en vez
      //    de cerrar. Esto elimina el pestaneo (abre/cierra) en equipos lentos.
      if (now - lastOpenAt < CART_OPEN_GRACE_MS) {
          scheduleCloseCart();
          return;
      }

      // 2) No cerrar si el cursor sigue realmente sobre el icono o el panel.
      //    Combinamos :hover (fiable ya estabilizado) con geometria del puntero
      //    (fiable durante transiciones), para no cerrar por error.
      const isHoveringIcon = document.querySelector('[data-js-cart-icon]:hover');
      const isHoveringContainer = document.querySelector('.quick-cart__container:hover');
      if (isHoveringIcon || isHoveringContainer || pointerOverCartZone()) {
          return;
      }

      closeQuickCart();
  }, 250);
}

/**
 * Quick Cart Hover Option
 * Opens the quick cart on hover if the setting is enabled in the Quick Cart section.
 */
document.addEventListener('DOMContentLoaded', function() {
    
    function updateHoverState() {
        const quickCartSection = document.querySelector('[data-section-type="quick-cart"]');
        const wrapper = document.querySelector('.quick-cart__wrapper');
        const isDesktop = window.innerWidth > 960; // Mobile breakpoint check (Matched to CSS)
        
        if (quickCartSection) {
            const behavior = quickCartSection.getAttribute('data-cart-behavior');
            
            // Only enable hover behavior if it's set to 'hover' AND we are on desktop
            if (behavior === 'hover' && isDesktop) {
                if (!document.body.classList.contains('quick-cart-hover-enabled')) {
                    document.body.classList.add('quick-cart-hover-enabled');
                }
                if(wrapper && !wrapper.classList.contains('quick-cart-hover-enabled')) {
                    wrapper.classList.add('quick-cart-hover-enabled');
                }
                return 'hover';
            } else {
                // If not hover OR not desktop, standard click behavior
                if (document.body.classList.contains('quick-cart-hover-enabled')) {
                    document.body.classList.remove('quick-cart-hover-enabled');
                }
                 if(wrapper && wrapper.classList.contains('quick-cart-hover-enabled')) {
                    wrapper.classList.remove('quick-cart-hover-enabled');
                }
                return 'click';
            }
        }
        return 'click'; // Default
    }

    // Initial check
    updateHoverState();

    // Listen for resize to toggle behavior dynamically
    window.addEventListener('resize', function() {
        updateHoverState();
    });

    // Unified Event Delegation
    document.body.addEventListener('mouseover', function(e) {
        const target = e.target;
        
        // 1. Hovering Icon
        const cartIcon = target.closest('[data-js-cart-icon]');
        if (cartIcon) {
            // Check global/section behavior
            const behavior = updateHoverState(); // Ensure state is synced
            
            if (behavior === 'hover') {
                openQuickCart();
            }
            return;
        }

        // 2. Hovering Container (any part of it)
        if (target.closest('.quick-cart__container')) {
            clearTimeout(closeCartTimeout);
        }
    });

    document.body.addEventListener('mouseout', function(e) {
        const target = e.target;
        const related = e.relatedTarget;
        
        // Helper to check if related target is "safe" (inside icon or container)
        function isSafelyInside(element) {
            if (!element) return false;
            // Check if element is inside icon
            if (element.closest('[data-js-cart-icon]')) return true;
            // Check if element is inside card drawer
            if (element.closest('.quick-cart__container')) return true;
            return false;
        }

        // 1. Leaving Icon
        const cartIcon = target.closest('[data-js-cart-icon]');
        // Check effective behavior (respects desktop limit)
        const behavior = updateHoverState(); 
        
        // Only trigger auto-close if behavior is 'hover'
        if (cartIcon && behavior === 'hover') {
             // If we didn't move to a safe place, close
             if (!isSafelyInside(related)) {
                 scheduleCloseCart();
             }
             return;
        }

        // 2. Leaving Container
        // We only care if we were *actually* in the container
        const container = target.closest('.quick-cart__container');
        if (container) {
            // Check if we left the container entirely
            if (!container.contains(related)) {
                 if (behavior === 'hover') {
                     // And check we didn't go back to icon
                     if (!isSafelyInside(related)) {
                         scheduleCloseCart();
                     }
                 }
            }
        }
    });
});

// add class in body as per os

const userAgent = navigator.userAgent.toLowerCase();
let browserName = '';

// Detect Brave first (since Brave also reports as Chrome)
if (navigator.brave && navigator.brave.isBrave) {
  navigator.brave.isBrave().then((isBrave) => {
    if (isBrave) {
      document.body.classList.add('browser-brave');
    } else {
      detectBrowser(); // fallback to others if not Brave
    }
  });
} else {
  detectBrowser();
}
function detectBrowser() {
  if (userAgent.includes('edge')) {
    browserName = 'edge';
  } else if (userAgent.includes('chrome')) {
    browserName = 'chrome';
  } else if (userAgent.includes('firefox')) {
    browserName = 'firefox';
  } else if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
    browserName = 'safari';
  } else if (userAgent.includes('opr') || userAgent.includes('opera')) {
    browserName = 'opera';
  } else if (userAgent.includes('msie') || userAgent.includes('trident')) {
    browserName = 'ie';
  }

  if (browserName) {
    document.body.classList.add('browser-' + browserName);
  }
}

// bottom menu

document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver(() => {
    const primary = document.querySelector('.drawer-menu__primary-links');
    const bottom = document.querySelector('.drawer-menu__list--bottom-menu');
    if (primary && bottom) {
      const depth = primary.getAttribute('data-depth') || '0';
      bottom.setAttribute('data-depth', depth);
      
      // Find the currently active submenu in bottom to ensure it aligns to top
      const activeSub = bottom.querySelector('.drawer-menu__list--sub.visible');
      if (activeSub && depth !== '0') {
          // The distance to offset is the negative of the bottom container's current top relative to the drawer main
          const mainRect = document.querySelector('.drawer-menu__main').getBoundingClientRect();
          const bottomRect = bottom.getBoundingClientRect();
          // Move the bottom menu up so its top aligns with the main container
      }
    }
  });
  const primaryLinks = document.querySelector('.drawer-menu__primary-links');
  if (primaryLinks) {
    observer.observe(primaryLinks, { attributes: true, attributeFilter: ['data-depth'] });
  }
});

/**
 * Preorder por metafields: custom.stock_status + custom.preorder_date.
 * Si stock_status es "In Stock" y preorder_date no está vacío → Add to cart. Si no → Preorder.
 * El mapa por variante viene en data-preorder-display-map (Liquid). Al cambiar variante se aplica sin API.
 */
(function () {
  function getCurrentVariantId(form) {
    var input = form.querySelector('[name="id"]') || form.querySelector('[data-variant-select]');
    var val = input && input.value;
    return val ? String(val).trim() : null;
  }

  function getDisplayMapFromForm(form) {
    var mapAttr = form.getAttribute('data-preorder-display-map');
    if (!mapAttr || mapAttr === '{}') return null;
    try {
      var parsed = JSON.parse(mapAttr);
      if (parsed && typeof parsed === 'object') return parsed;
    } catch (e) {}
    return null;
  }

  function applyPreorderOverride(container, variantId, displayMap) {
    if (!container || !variantId || !displayMap) return;
    var variantIdNum = String(variantId).replace(/^.*\//, '');
    var showAddToCart = displayMap[variantIdNum] || displayMap[variantId];

    var addToCartBtns = container.querySelectorAll('[data-add-to-cart]');
    var preorderBlocks = container.querySelectorAll('[data-preorder-delivery-block]');
    var preorderInputs = container.querySelectorAll('[data-preorder-delivery-input]');

    if (showAddToCart) {
      addToCartBtns.forEach(function (btn) {
        var label = btn.dataset && btn.dataset.langAvailable;
        var textEl = btn.querySelector('[data-add-to-cart-text]');
        if (textEl && label) textEl.textContent = label;
      });
      preorderBlocks.forEach(function (block) { block.classList.add('hidden'); });
      preorderInputs.forEach(function (input) {
        input.removeAttribute('name');
        input.value = '';
      });
      return;
    }

    var form = container.querySelector && container.querySelector('[data-product-form]') || (container.matches && container.matches('form[data-product-form]') ? container : null);
    if (!form) return;
    var datesJson = form.dataset && form.dataset.preorderDeliveryDates;
    var dates = {};
    if (datesJson) try { dates = JSON.parse(datesJson); } catch (err) {}
    var dateVal = dates[variantIdNum] || dates[variantId];
    var btn = addToCartBtns[0];
    var preorderIdsJson = btn && btn.dataset && btn.dataset.preorderVariantIds;
    var isPreorderVariant = false;
    if (preorderIdsJson) try {
      var ids = JSON.parse(preorderIdsJson);
      isPreorderVariant = Array.isArray(ids) && ids.some(function (id) { return String(id) === String(variantIdNum) || Number(id) === Number(variantIdNum); });
    } catch (err) {}
    if (!isPreorderVariant || !dateVal) return;
    addToCartBtns.forEach(function (b) {
      var label = b.dataset && b.dataset.langPreorder;
      var textEl = b.querySelector('[data-add-to-cart-text]');
      if (textEl && label) textEl.textContent = label;
    });
    preorderBlocks.forEach(function (block) { block.classList.remove('hidden'); });
    var dateDisplay = container.querySelector('[data-preorder-date-display]');
    if (dateDisplay) dateDisplay.textContent = dateVal;
    preorderInputs.forEach(function (input) {
      var propName = (input.dataset && input.dataset.propertyName) || 'Estimated delivery';
      input.setAttribute('name', 'properties[' + propName + ']');
      input.value = dateVal;
    });
  }

  function runForAllProductForms() {
    var forms = document.querySelectorAll('form[data-product-form][data-product-id][data-has-preorder-variant="true"]');
    forms.forEach(function (form) {
      var section = form.closest('[data-section-id]');
      var container = section || form;
      var variantId = getCurrentVariantId(form);
      if (!variantId) return;
      var map = getDisplayMapFromForm(form);
      if (map) applyPreorderOverride(container, variantId, map);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    runForAllProductForms();
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          var form = node.querySelector && node.querySelector('form[data-product-form][data-product-id][data-has-preorder-variant="true"]') || (node.matches && node.matches('form[data-product-form][data-product-id][data-has-preorder-variant="true"]') ? node : null);
          if (form) runForAllProductForms();
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener('product:variant-change', function () {
    runForAllProductForms();
  });

  document.body.addEventListener('change', function (e) {
    var form = e.target.closest('form[data-product-form][data-product-id][data-has-preorder-variant="true"]');
    if (!form && e.target.matches && e.target.matches('form[data-product-form][data-product-id][data-has-preorder-variant="true"]'))
      form = e.target;
    if (form) runForAllProductForms();
  }, true);

  // Inline header search (Option B) — expands an input to the left of the search icon
  document.addEventListener('click', function (e) {
    const toggle = e.target.closest('[data-inline-search-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      const wrap = toggle.closest('[data-inline-search-wrap]');
      if (!wrap) return;
      // Close any other open inline search
      document.querySelectorAll('[data-inline-search-wrap].is-open').forEach(function (w) {
        if (w !== wrap) w.classList.remove('is-open');
      });
      const isOpen = wrap.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        const input = wrap.querySelector('[data-inline-search-input]');
        if (input) setTimeout(function () { input.focus(); }, 50);
      }
      return;
    }
    // Click outside — close any open inline search
    if (!e.target.closest('[data-inline-search-wrap]')) {
      document.querySelectorAll('[data-inline-search-wrap].is-open').forEach(function (w) {
        w.classList.remove('is-open');
        const t = w.querySelector('[data-inline-search-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // Esc closes inline search
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-inline-search-wrap].is-open').forEach(function (w) {
      w.classList.remove('is-open');
      const t = w.querySelector('[data-inline-search-toggle]');
      if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
    });
  });

  // Swym wishlist text overrides — quita los signos de exclamación
  const swymTextReplacements = [
    { from: /Your collections are to stay here forever!/g, to: 'Your collections are to stay here forever.' },
    { from: /Login to save your stuff for good and access them whenever, wherever!/g, to: 'Login to save your stuff for good and access them whenever, wherever.' },
  ];

  function replaceSwymText(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    const nodes = [];
    let n;
    while ((n = walker.nextNode())) {
      const t = n.nodeValue;
      if (!t) continue;
      for (const r of swymTextReplacements) {
        if (r.from.test(t)) { nodes.push(n); break; }
        r.from.lastIndex = 0;
      }
    }
    nodes.forEach(node => {
      let v = node.nodeValue;
      swymTextReplacements.forEach(r => { v = v.replace(r.from, r.to); });
      if (v !== node.nodeValue) node.nodeValue = v;
    });
  }

  const swymObserver = new MutationObserver(function (mutations) {
    mutations.forEach(m => {
      m.addedNodes.forEach(n => {
        if (n.nodeType === 1) replaceSwymText(n);
      });
    });
  });
  swymObserver.observe(document.body, { childList: true, subtree: true });
  // Run once at start in case texts are already in the DOM
  replaceSwymText(document.body);
})();

/**
 * Mobile drawer redesign 2026 (scoped to .drawer-menu--redesign-2026).
 *
 * Why this is structured the way it is:
 *   The theme attaches `clickParent` directly to each <a data-item="parent">
 *   via element.addEventListener('click', handler) (theme.js ~line 7935).
 *   That listener triggers a horizontal slide by changing the primary-links
 *   data-depth attribute. Document-capture stopPropagation does NOT cancel
 *   listeners registered on the target element itself in the AT_TARGET phase.
 *
 *   So we CLONE the parent-link <a> (clones do not inherit listeners), replace
 *   the original, and attach our own click handler that toggles an inline
 *   accordion. We also block back-link clicks (no horizontal slide to undo).
 */
(function () {
  const REDESIGN_CLASS = 'drawer-menu--redesign-2026';
  const PROCESSED_ATTR = 'data-redesign-bound';

  function rewireParentLinks(root) {
    // Handles both the primary parent links (READY TO WEAR / THE BRAND) and
    // the bottom Help link (data-item="bottom-parent"). Both behaviours are
    // identical: clone the <a> to drop theme.js listeners, then toggle an
    // expanded class on the parent <li>.
    const links = root.querySelectorAll('a[data-item="parent"], a[data-item="bottom-parent"]');
    links.forEach(function (oldLink) {
      if (oldLink.getAttribute(PROCESSED_ATTR) === '1') return;
      const newLink = oldLink.cloneNode(true);
      newLink.setAttribute(PROCESSED_ATTR, '1');
      const isBottom = newLink.getAttribute('data-item') === 'bottom-parent';
      const expandedClass = isBottom
        ? 'drawer-menu__bottom-item--expanded'
        : 'drawer-menu__item--expanded';
      newLink.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const li = newLink.closest('li.drawer-menu__item');
        if (!li) return;
        const expanded = li.classList.toggle(expandedClass);
        newLink.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        // Toggle the sibling sub-list's .visible class to match (so any theme
        // CSS keyed off .visible behaves consistently).
        const subList = newLink.nextElementSibling;
        if (subList && subList.classList.contains('drawer-menu__list--sub')) {
          subList.classList.toggle('visible', expanded);
          subList.setAttribute('aria-hidden', expanded ? 'false' : 'true');
        }
      });
      oldLink.parentNode.replaceChild(newLink, oldLink);
    });
  }

  function rewireBackLinks(root) {
    // Inside the redesign there is no horizontal slide, so neutralise back.
    const backs = root.querySelectorAll('[data-item="back"]');
    backs.forEach(function (oldBack) {
      if (oldBack.getAttribute(PROCESSED_ATTR) === '1') return;
      const newBack = oldBack.cloneNode(true);
      newBack.setAttribute(PROCESSED_ATTR, '1');
      newBack.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
      oldBack.parentNode.replaceChild(newBack, oldBack);
    });
  }

  function initRedesignDrawers() {
    const drawers = document.querySelectorAll('.' + REDESIGN_CLASS);
    drawers.forEach(function (drawer) {
      rewireParentLinks(drawer);
      rewireBackLinks(drawer);
    });
  }

  // Run after theme.js has attached its listeners. theme.js is loaded as a
  // module/defer script so DOMContentLoaded is the right milestone, plus a
  // small timeout to win the race against theme initialisation.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initRedesignDrawers, 50);
    });
  } else {
    setTimeout(initRedesignDrawers, 50);
  }

  // Re-run when the drawer is re-rendered (e.g. after section editor reload
  // or async menu refresh).
  const observer = new MutationObserver(function () {
    initRedesignDrawers();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Note: the bottom Help accordion is now handled inside rewireParentLinks()
  // via the [data-item="bottom-parent"] selector. No separate handler needed.
})();



/**
 * FAQ Help Center — mobile-only category dropdown selector.
 * Below 769px:
 *   - Default: FAQ category is shown (data-mobile-active="true").
 *   - Click "Choose a category" toggle → opens dropdown with non-FAQ options.
 *   - Click a dropdown option → that category becomes active, others hidden.
 *   - The toggle label updates to show the selected category name.
 *
 * Desktop is untouched (CSS hides the selector with display:none above 768px).
 * Viewport checks happen INSIDE handlers so listeners are harmless on desktop.
 */
(function () {
  function setMobileActiveCategory(filterValue) {
    const groups = document.querySelectorAll(".help-center__category-group");
    groups.forEach(function (group) {
      const cat = group.getAttribute("data-category");
      if (cat === filterValue) {
        group.setAttribute("data-mobile-active", "true");
      } else {
        group.removeAttribute("data-mobile-active");
      }
    });
  }

  function bindHelpCenterMobileSelector() {
    const selectors = document.querySelectorAll("[data-mobile-selector]");
    selectors.forEach(function (selector) {
      if (selector.dataset.mobileSelectorBound === "1") return;
      selector.dataset.mobileSelectorBound = "1";

      const toggle = selector.querySelector("[data-mobile-toggle]");
      const label = selector.querySelector("[data-mobile-label]");
      const options = selector.querySelectorAll("[data-mobile-option]");

      if (toggle) {
        toggle.addEventListener("click", function () {
          if (window.innerWidth >= 769) return;
          const isOpen = selector.getAttribute("data-open") === "true";
          selector.setAttribute("data-open", isOpen ? "false" : "true");
          toggle.setAttribute("aria-expanded", isOpen ? "false" : "true");
        });
      }

      options.forEach(function (option) {
        option.addEventListener("click", function (e) {
          if (window.innerWidth >= 769) return;
          e.preventDefault();
          e.stopPropagation();
          const filter = option.getAttribute("data-filter-link");
          if (label) label.textContent = option.textContent.trim();
          selector.setAttribute("data-open", "false");
          if (toggle) toggle.setAttribute("aria-expanded", "false");
          setMobileActiveCategory(filter);
        });
      });
    });

    // Default state on mobile: FAQ category active
    if (window.innerWidth < 769) {
      setMobileActiveCategory("FAQ");
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindHelpCenterMobileSelector);
  } else {
    bindHelpCenterMobileSelector();
  }
})();



/**
 * Quick-search overlay state — toggle a body class so we can hide the
 * drawer's burger/X and the search trigger via CSS without relying on
 * :has() (which older Safari versions don't support).
 */
(function () {
  function watchQuickSearch() {
    // When the user taps the search icon while the drawer is open, close the
    // drawer first so they don't see two X icons stacked. The search overlay
    // continues to open as normal and its own close (X) handles dismissal.
    document.addEventListener('click', function (e) {
      const t = e.target.closest('.header__icon-touch--search, [aria-label*="search modal" i]');
      if (!t) return;
      const drawer = document.querySelector('.drawer-menu');
      const burger = document.querySelector('.header__menu-icon[aria-expanded="true"]');
      if (drawer && burger) {
        // Drawer is open — trigger the burger button to close it.
        burger.click();
      }
    }, true);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchQuickSearch);
  } else {
    watchQuickSearch();
  }
})();
